export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "ASOIF Strategy Report 2026-2032",
    "shortTitle": "",
    "description": "",
    "width": 1263,
    "height": 893,
    "currentLanguage": "EN",
    "languages": [],
    // "basePath": "",
    "basePath": "/strategy",
    "companyLogo": "1-logo-1.png",
    "publishURL": "https://reports.asoif.com/strategy/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "subscribeEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/strategy/static/_content/ASOIF_Strategy_2026-2032.pdf',
      "printEnabled": false,
      "zoom": {
        "navEnabled": false,
        "sliderEnabled": true,
        "clickEnabled": true,
        "scrollEnabled": true,
      },
      "contents": {
        "enabled": true,
        "pinned": false,
        "numbers": true,
        "titles": true,
      },
      "languagesEnabled": false,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
      "fullscreenEnabled": true,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 1-title" style="top:569px;left:81px;" src="/strategy/static/_content/1-title-1.png"/>
        <img class="abs halfScale 1-sub" style="top:479px;left:83px;" src="/strategy/static/_content/1-sub-1.png"/>
        <img class="abs halfScale 1-line" style="top:538px;left:82px;" src="/strategy/static/_content/1-line-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-line"), 0.6, {opacity: 0, x: 40}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("1-title"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("1-sub"), 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.2")
          
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "2026–2032  ASOIF STRATEGY"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 2-title" style="top:79px;left:204px;" src="/strategy/static/_content/2-title-1.png"/>
        <img class="abs halfScale 2-sub" style="top:138px;left:203px;" src="/strategy/static/_content/2-sub-1.png"/>
        <img class="abs halfScaleC 2-icon" style="top:3px;left:1px;" src="/strategy/static/_content/2-icon-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.fromTo(cOf("2-title"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("2-sub"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("2-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, "-=0.2")
          
        }

        function onPageLeave() {
          pg2Anim.stop();
        }
      `,
      "searchText": "FOREWORD Dear Presidents and Secretaries General, dear Colleagues and Friends,  As we move into the next phase of ASOIF’s strategy development, it is important to reflect on the changing environment in which we operate and the role ASOIF must now play. In past years, we were navigating a period of intense scrutiny and reform within international sport. At that time, ASOIF focused on supporting its members in strengthening governance, reinforcing the autonomy of International Federations (IFs) and coordinating Games-related responsibilities. It was a necessary and measured response to external pressures, with the governance work in particular becoming one of ASOIF’s most successful projects. Today, IFs are operating in a more complex and unpredictable environment. Pressures now come from government policy, regulators, commercial needs and public society. IFs are being asked to do more with the same resources. Simultaneously, the diversity within our membership has increased, both in terms of scale and strategic need. Following the wide-ranging consultation, I actioned at the start of my mandate, it became clear that clarity and transparency are essential for ASOIF moving forward with our core priorities. This includes our ability and efforts in advocating and representing our members’ interests, such as seeking clarity for Olympic Games revenue distribution, the sport programme,  the role of the IF in Olympic Games planning and operational delivery, as well as facilitating collaboration and knowledge sharing initiatives. As a result, the new strategy takes a more deliberate and forward-looking approach. It maintains ASOIF’s core purpose while sharpening its focus. Greater emphasis is given to collaboration and influence, with the purpose of championing the role of the IF whilst also protecting the jurisdiction and mandate of the IF. Our new strategy outlines the direction of travel of ASOIF, providing a clear path to guide collective action and ensure that all members, regardless of size or maturity, are equipped to succeed amongst the increasing pressures placed on the role of the IF.  INGMAR DE VOS ASOIF PRESIDENT  ASO IF ST R AT EGY 2 02 6 – 2 032  2"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 3-title" style="top:376px;left:66px;" src="/strategy/static/_content/3-title-1.png"/>
        <img class="abs halfScale 3-sub-1" style="top:570px;left:66px;" src="/strategy/static/_content/3-sub-1.png"/>
        <img class="abs halfScale 3-sub-2" style="top:571px;left:486px;" src="/strategy/static/_content/3-sub-2.png"/>
        <img class="abs halfScale 3-line-1" style="top:609px;left:64px;" src="/strategy/static/_content/3-line-1.png"/>
        <img class="abs halfScale 3-line-2" style="top:609px;left:486px;" src="/strategy/static/_content/3-line-1.png"/>
        <img class="abs halfScale 3-text-1" style="top:638px;left:65px;" src="/strategy/static/_content/3-text-1.png"/>
        <img class="abs halfScale 3-text-2" style="top:639px;left:486px;" src="/strategy/static/_content/3-text-2.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.fromTo(cOf("3-title"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("3-line-1"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("3-sub-1"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(cOf("3-text-1"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(cOf("3-line-2"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(cOf("3-sub-2"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(cOf("3-text-2"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.4")
          
        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": "MISSION, VISION & PRINCIPLES MISSION  VISION  ASOIF exists to represent, strengthen and grow the collective influence of the Summer Olympic International Federations within the Olympic and Sports Movement.  A unified and influential community, essential to the success and evolution of the Olympic and Sports Movement.  ASO IF ST R AT EGY 2 02 6 – 2 032  3"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 4-sub-1" style="top:158px;left:65px;" src="/strategy/static/_content/4-sub-1.png"/>
        <img class="abs halfScale 4-sub-2" style="top:158px;left:354px;" src="/strategy/static/_content/4-sub-2.png"/>
        <img class="abs halfScale 4-line-1" style="top:196px;left:63px;" src="/strategy/static/_content/4-line-1.png"/>
        <img class="abs halfScale 4-line-2" style="top:196px;left:353px;" src="/strategy/static/_content/4-line-1.png"/>
        <img class="abs halfScale 4-text" style="top:249px;left:426px;" src="/strategy/static/_content/4-text-1.png"/>
        <img class="abs halfScale 4-text" style="top:331px;left:426px;" src="/strategy/static/_content/4-text-2.png"/>
        <img class="abs halfScale 4-text" style="top:418px;left:426px;" src="/strategy/static/_content/4-text-3.png"/>
        <img class="abs halfScale 4-text" style="top:497px;left:426px;" src="/strategy/static/_content/4-text-4.png"/>
        <img class="abs halfScaleC 4-icon" style="top:213px;left:329px;" src="/strategy/static/_content/4-icon-1.png"/>
        <img class="abs halfScaleC 4-icon" style="top:300px;left:325px;" src="/strategy/static/_content/4-icon-2.png"/>
        <img class="abs halfScaleC 4-icon" style="top:387px;left:323px;" src="/strategy/static/_content/4-icon-3.png"/>
        <img class="abs halfScaleC 4-icon" style="top:469px;left:325px;" src="/strategy/static/_content/4-icon-4.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.fromTo(cOf("4-sub-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("4-sub-2"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("4-line-1"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(cOf("4-line-2"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.4")
          .staggerFromTo(cOf("4-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.2, "-=0.4")
          .staggerFromTo(cOf("4-text"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=0.8")          
        }

        function onPageLeave() {
          pg4Anim.stop();
        }
      `,
      "searchText": "MISSION, VISION & PRINCIPLES  ROLE  GUIDING PRINCIPLES  Advocacy Championing the rights, responsibilities and autonomy of the Summer Olympic International Federations, ensuring their voice is central in the Olympic Movement, Olympic Games planning and international sport governance.  Coordination Coordinating strategic collaboration and communication across the Summer Olympic International Federations, whilst seeking constructive alignment with the International Olympic Committee (IOC) and Organising Committees for the Olympic Games (OCOGs), enabling joint approaches to common challenges and opportunities.  MEMBER FOCUS COLLECTIVE VALUE CLARITY & TRANSPARENCY FUTURE READINESS  In fulfilling this role, ASOIF ensures that its members are equipped to uphold their mandates, defend their interests and succeed in achieving their objectives.  ASO IF ST R AT EGY 2 02 6 – 2 032  4"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 5-title-1" style="top:90px;left:66px;" src="/strategy/static/_content/5-title-1.png"/>
        <img class="abs halfScale 5-text" style="top:617px;left:64px;" src="/strategy/static/_content/5-text-1.png"/>
        <img class="abs halfScale 5-text" style="top:617px;left:450px;" src="/strategy/static/_content/5-text-2.png"/>
        <img class="abs halfScale 5-text" style="top:617px;left:835px;" src="/strategy/static/_content/5-text-3.png"/>
        <img class="abs halfScaleC 5-icon" style="top:478px;left:31px;" src="/strategy/static/_content/5-icon-1.png"/>
        <img class="abs halfScaleC 5-icon" style="top:478px;left:418px;" src="/strategy/static/_content/5-icon-2.png"/>
        <img class="abs halfScaleC 5-icon" style="top:478px;left:797px;" src="/strategy/static/_content/5-icon-3.png"/>

        <div class="addContentLink" onclick="Publish.goToPage(6);" style="top: 608px;left: 56px;width: 260px;height: 64px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(9);" style="top: 608px;left: 445px;width: 186px;height: 64px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(12);" style="top: 608px;left: 832px;width: 269px;height: 64px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.fromTo(cOf("5-title-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("5-text"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .staggerFromTo(cOf("5-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 0.2, "-=0.6")          
        }

        function onPageLeave() {
          pg5Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "CORE PRIORITIES  ADVOCACY, INFLUENCE & REPRESENTATION  OLYMPIC GAMES EXCELLENCE  COLLABORATION & KNOWLEDGE SHARING  Advance the collective voice, autonomy and standing of IFs by representing shared interests, upholding high governance standards and strengthening influence within the Olympic Movement, sport and society.  Secure meaningful and structured involvement of IFs in IOC and OCOG decision-making processes while maintaining a constructive and strategically aligned partnership with the IOC.  Coordinate structured collaboration on shared challenges and priorities, ensuring ASOIF mechanisms and initiatives respond to member-driven needs and facilitate informed exchange, alignment and collective solutions where appropriate.  ASO IF ST R AT EGY 2 02 6 – 2 032  5"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 6-title-1" style="top:598px;left:67px;" src="/strategy/static/_content/6-title-1.png"/>
        <img class="abs halfScale 6-sub" style="top:748px;left:64px;" src="/strategy/static/_content/6-sub-1.png"/>
        <img class="abs halfScale 6-sub" style="top:434px;left:933px;" src="/strategy/static/_content/6-sub-2.png"/>
        <img class="abs halfScaleC 6-icon" style="top:244px;left:879px;" src="/strategy/static/_content/6-icon-1.png"/>
        <img class="abs halfScale 6-line" style="top:478px;left:931px;" src="/strategy/static/_content/6-line-1.png"/>
        <img class="abs halfScale 6-line" style="top:561px;left:931px;" src="/strategy/static/_content/6-line-1.png"/>
        <img class="abs halfScale 6-line" style="top:643px;left:931px;" src="/strategy/static/_content/6-line-1.png"/>
        <img class="abs halfScale 6-line" style="top:726px;left:931px;" src="/strategy/static/_content/6-line-1.png"/>
        <img class="abs halfScale 6-line" style="top:786px;left:931px;" src="/strategy/static/_content/6-line-1.png"/>
        <img class="abs halfScale 6-text" style="top:493px;left:933px;" src="/strategy/static/_content/6-text-1.png"/>
        <img class="abs halfScale 6-text" style="top:575px;left:933px;" src="/strategy/static/_content/6-text-2.png"/>
        <img class="abs halfScale 6-text" style="top:658px;left:933px;" src="/strategy/static/_content/6-text-3.png"/>
        <img class="abs halfScale 6-text" style="top:740px;left:933px;" src="/strategy/static/_content/6-text-4.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.fromTo(cOf("6-title-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("6-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .fromTo(cOf("6-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, "-=0.2")  
          .staggerFromTo(cOf("6-line"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .staggerFromTo(cOf("6-text"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=1.2")        
        }

        function onPageLeave() {
          pg6Anim.stop();
        }
      `,
      "searchText": "STRATEGIC OBJECTIVES 1.  Represent IFs collectively in Olympic and global sport decision-making  ADVOCACY, INFLUENCE & REPRESENTATION  2.  Defend IF autonomy and promote recognition of their role  3.  Elevate IF visibility and expertise across sport and society  Advance the collective voice, autonomy and standing of IFs by representing shared interests, upholding high governance standards and strengthening influence within the Olympic Movement, sport and society.  4.  Uphold IF governance standards  ASO IF ST R AT EGY 2 02 6 – 2 032  6"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 7-sub" style="top:177px;left:64px;" src="/strategy/static/_content/7-sub-1.png"/>
        <img class="abs halfScale 7-sub" style="top:177px;left:354px;" src="/strategy/static/_content/7-sub-2.png"/>
        <img class="abs halfScale 7-quote" style="top:697px;left:370px;" src="/strategy/static/_content/7-quote-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.staggerFromTo(cOf("7-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("7-quote"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")        
        }

        function onPageLeave() {
          pg7Anim.stop();
        }
      `,
      "searchText": "ADVOCACY, INFLUENCE & REPRESENTATION  1.  2.  Represent collective IF positions on Olympic and global sport matters through structured engagement with the IOC and other key institutions  Defend and uphold the principle of IF autonomy and ensure the IF role is understood and respected in all relevant governance structures  • Coordinate consensus-based positions across members on policies impacting sport  •  Monitor and respond to any external actions that may erode IF independence or mandate  •  Provide unified responses to global threats or interference in IF governance  • Engage with the IOC and other relevant stakeholders on shared issues of process and policy  •  • Provide timely representation where IF mandates or priorities are directly affected (the World Anti-Doping Agency (WADA), SportAccord, the International Testing Agency (ITA), the Court of Arbitration for Sport (CAS), etc.) • Promote the role and value of the IFs in international sport governance, development and delivery  ASOIF champions the rights, responsibilities and autonomy of the Summer Olympic IFs  ASO IF ST R AT EGY 2 02 6 – 2 032  7"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-sub" style="top:177px;left:644px;" src="/strategy/static/_content/8-sub-1.png"/>
        <img class="abs halfScale 8-sub" style="top:177px;left:932px;" src="/strategy/static/_content/8-sub-2.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.staggerFromTo(cOf("8-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)      
        }

        function onPageLeave() {
          pg8Anim.stop();
        }
      `,
      "searchText": "ADVOCACY, INFLUENCE & REPRESENTATION  3.  4.  Advance the strategic role, visibility and impact of IF expertise across sport and society  Uphold IF governance standards  •  •  Promote IF capabilities and expertise as regulators and innovators in global sport Explore IF participation in global governance and policy forums (the United Nations (UN), the World Health Organization (WHO), the Organisation for Economic Co-operation and Development (OECD), the Council of Europe, etc.) where appropriate  •  Modernise the ASOIF Governance Task Force assessment to reflect current IF maturity and practical use  •  Support members in demonstrating transparency, accountability and independence  •  Promote good governance as a strategic driver of collective credibility and influence  ASO IF ST R AT EGY 2 02 6 – 2 032  8"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 9-title-1" style="top:598px;left:67px;" src="/strategy/static/_content/9-title-1.png"/>
        <img class="abs halfScale 9-sub" style="top:748px;left:64px;" src="/strategy/static/_content/9-sub-1.png"/>
        <img class="abs halfScale 9-sub" style="top:373px;left:933px;" src="/strategy/static/_content/9-sub-2.png"/>
        <img class="abs halfScaleC 9-icon" style="top:185px;left:879px;" src="/strategy/static/_content/9-icon-1.png"/>
        <img class="abs halfScale 9-line" style="top:416px;left:931px;" src="/strategy/static/_content/9-line-1.png"/>
        <img class="abs halfScale 9-line" style="top:540px;left:931px;" src="/strategy/static/_content/9-line-1.png"/>
        <img class="abs halfScale 9-line" style="top:643px;left:931px;" src="/strategy/static/_content/9-line-1.png"/>
        <img class="abs halfScale 9-line" style="top:726px;left:931px;" src="/strategy/static/_content/9-line-1.png"/>
        <img class="abs halfScale 9-line" style="top:786px;left:931px;" src="/strategy/static/_content/9-line-1.png"/>
        <img class="abs halfScale 9-text" style="top:430px;left:933px;" src="/strategy/static/_content/9-text-1.png"/>
        <img class="abs halfScale 9-text" style="top:554px;left:933px;" src="/strategy/static/_content/9-text-2.png"/>
        <img class="abs halfScale 9-text" style="top:658px;left:933px;" src="/strategy/static/_content/9-text-3.png"/>
        <img class="abs halfScale 9-text" style="top:740px;left:933px;" src="/strategy/static/_content/9-text-4.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(cOf("9-title-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("9-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .fromTo(cOf("9-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, "-=0.2")  
          .staggerFromTo(cOf("9-line"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .staggerFromTo(cOf("9-text"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=1.2")        
        }

        function onPageLeave() {
          pg9Anim.stop();
        }
      `,
      "searchText": "STRATEGIC OBJECTIVES  OLYMPIC GAMES EXCELLENCE Secure meaningful and structured involvement of IFs in IOC and OCOG decision-making processes while maintaining a constructive and strategically aligned partnership with the IOC.  1.  Contribute to the establishment of a clear and objective process and methodology for determining the Olympic Games Sport Programme  2.  Clarify Olympic Games revenue distribution based upon transparent and objective criteria  3.  Promote consistent IF roles and coordination in Games planning and delivery  4.  Strengthen Olympic issue tracking and resolution  ASO IF ST R AT EGY 2 02 6 – 2 032  9"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-sub" style="top:177px;left:64px;" src="/strategy/static/_content/7-sub-1.png"/>
        <img class="abs halfScale 10-sub" style="top:177px;left:354px;" src="/strategy/static/_content/7-sub-2.png"/>
        <img class="abs halfScale 10-quote" style="top:643px;left:370px;" src="/strategy/static/_content/10-quote-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.staggerFromTo(cOf("10-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("10-quote"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")        
        }

        function onPageLeave() {
          pg10Anim.stop();
        }
      `,
      "searchText": "OLYMPIC GAMES EXCELLENCE  1.  2.  Contribute to the establishment of a clear and objective process and methodology for determining the Olympic Games Sport Programme, including inclusion/exclusion criteria, quotas and review processes  Secure a long-term agreement and understanding with the IOC in reviewing and clarifying Olympic Games revenue distribution, ensuring transparency, objectivity, collective input and recognition for ASOIF’s evolving membership structure  •  Engage with the IOC to seek greater clarity on sport programme inclusion/exclusion criteria for Olympic Games and Youth Olympic Games, associated timelines and decision-making processes  •  Continue to make the case for greater revenue share for IFs  •  Review and clarify the link between Olympic Games sport programme status and revenue distribution  •  In collaboration with the IOC, establish a member-facing reference guide outlining the key stages, stakeholders and procedures for Olympic Games sport programme inclusion/exclusion  •  Explore feasible models for future revenue distribution and their impact on members  •  Track and consolidate member perspectives to inform collective ASOIF advocacy  •  Maintain regular communication with members regarding dialogue with the IOC on the programme process  •  ASOIF seeks constructive alignment with the IOC and OCOGs, enabling joint approaches to common challenges and opportunities  ASO IF ST R AT EGY 2 02 6 – 2 032  10"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 11-sub" style="top:173px;left:644px;" src="/strategy/static/_content/8-sub-1.png"/>
        <img class="abs halfScale 11-sub" style="top:173px;left:932px;" src="/strategy/static/_content/8-sub-2.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.staggerFromTo(cOf("11-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)      
        }

        function onPageLeave() {
          pg11Anim.stop();
        }
      `,
      "searchText": "OLYMPIC GAMES EXCELLENCE  3.  4.  Improve IF influence, coordination and clarity in Olympic and Youth Olympic Games planning and delivery structures  Enhance ASOIF’s existing mechanisms to raise, record and monitor shared IF concerns and operational issues across Olympic Games (OG) and Youth Olympic Games (YOG) planning and delivery cycles  • Identify and analyse inconsistencies in IF roles across recent Games to inform structured dialogue with IOC and OCOGs • Advocate for clearer expectations and cyclical timelines for IF and ASOIF involvement in all Games-time functions • Map IF participation in IOC-OCOG planning functions to identify gaps and opportunities for coordinated input • Establish ASOIF coordination mechanisms to support IF representatives and share key updates across members • Strengthen two-way communication with members to ensure collective insights inform future Games planning  • Formalise and upgrade ASOIF’s existing Olympic issue tracking system • Define categories and thresholds for identifying issues of shared concern versus sport-specific matters • Establish regular engagement points with IOC and OCOGs to raise and follow up on recurring challenges • Provide IFs with regular updates on how issues are being addressed (or otherwise) by relevant stakeholders • Identify trends to inform future Games planning and support early resolution  ASO IF ST R AT EGY 2 02 6 – 2 032  11"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 12-title-1" style="top:598px;left:67px;" src="/strategy/static/_content/12-title-1.png"/>
        <img class="abs halfScale 12-sub" style="top:748px;left:64px;" src="/strategy/static/_content/12-sub-1.png"/>
        <img class="abs halfScale 12-sub" style="top:456px;left:933px;" src="/strategy/static/_content/12-sub-2.png"/>
        <img class="abs halfScaleC 12-icon" style="top:271px;left:879px;" src="/strategy/static/_content/12-icon-1.png"/>
        <img class="abs halfScale 12-line" style="top:499px;left:931px;" src="/strategy/static/_content/12-line-1.png"/>
        <img class="abs halfScale 12-line" style="top:581px;left:931px;" src="/strategy/static/_content/12-line-1.png"/>
        <img class="abs halfScale 12-line" style="top:664px;left:931px;" src="/strategy/static/_content/12-line-1.png"/>
        <img class="abs halfScale 12-line" style="top:726px;left:931px;" src="/strategy/static/_content/12-line-1.png"/>
        <img class="abs halfScale 12-line" style="top:786px;left:931px;" src="/strategy/static/_content/12-line-1.png"/>
        <img class="abs halfScale 12-text" style="top:513px;left:933px;" src="/strategy/static/_content/12-text-1.png"/>
        <img class="abs halfScale 12-text" style="top:596px;left:933px;" src="/strategy/static/_content/12-text-2.png"/>
        <img class="abs halfScale 12-text" style="top:678px;left:933px;" src="/strategy/static/_content/12-text-3.png"/>
        <img class="abs halfScale 12-text" style="top:740px;left:933px;" src="/strategy/static/_content/12-text-4.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-title-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("12-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .fromTo(cOf("12-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, "-=0.2")  
          .staggerFromTo(cOf("12-line"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, "-=0.2")
          .staggerFromTo(cOf("12-text"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, "-=1.2")        
        }

        function onPageLeave() {
          pg12Anim.stop();
        }
      `,
      "searchText": "STRATEGIC OBJECTIVES  COLLABORATION & KNOWLEDGE SHARING Coordinate structured collaboration on shared challenges and priorities, ensuring ASOIF mechanisms and initiatives respond to member-driven needs and facilitate informed exchange, alignment and collective solutions where appropriate.  1.  Develop and modernise platforms for knowledge exchange and shared learning  2.  Deliver thematic coordination through commissions and task forces  3.  Facilitate joint initiatives where collective action adds value  4.  Strengthen member visibility and internal communication  ASO IF ST R AT EGY 2 02 6 – 2 032  12"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 13-sub" style="top:177px;left:64px;" src="/strategy/static/_content/7-sub-1.png"/>
        <img class="abs halfScale 13-sub" style="top:177px;left:354px;" src="/strategy/static/_content/7-sub-2.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.staggerFromTo(cOf("13-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)      
        }

        function onPageLeave() {
          pg13Anim.stop();
        }
      `,
      "searchText": "COLLABORATION & KNOWLEDGE SHARING  1.  2.  Modernise and strengthen knowledge platforms that enable sharing of good practice, benchmarks, and lessons learned across IFs at different stages of maturity  Deliver thematic coordination through commissions and task forces based on member-raised challenges or emerging global issues  • Deliver focused workshops, webinars and knowledge-sharing sessions aligned to member priorities and sector developments • Ensure content is member and demand-led, regularly evaluated and not a duplication of existing IF work • Maintain a centralised digital platform to host ASOIF outputs, case studies and shared resources • Produce and circulate briefings, tools and practical guides addressing recurring or complex member challenges  •  • Produce updated Terms of Reference for all commissions, ensuring inclusive representation and clarity in scope and remit • Map each commission’s scope against wider industry initiatives to align efforts and extend IF influence externally where deemed appropriate • Approve cyclical workplans for each commission, jointly set by Commission Chairs and ASOIF Council, with flexibility to address emerging priorities • Re-introduce structured annual reporting of collaboration and knowledge sharing initiatives to the ASOIF General Assembly or Annual Working Meeting  ASO IF ST R AT EGY 2 02 6 – 2 032  13"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 14-sub" style="top:177px;left:644px;" src="/strategy/static/_content/8-sub-1.png"/>
        <img class="abs halfScale 14-sub" style="top:177px;left:933px;" src="/strategy/static/_content/8-sub-2.png"/>
        <img class="abs halfScale 14-quote" style="top:671px;left:948px;" src="/strategy/static/_content/14-quote-1.png"/>
        
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim.staggerFromTo(cOf("14-sub"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)  
          .fromTo(cOf("14-quote"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")    
        }

        function onPageLeave() {
          pg14Anim.stop();
        }
      `,
      "searchText": "COLLABORATION & KNOWLEDGE SHARING  3.  4.  Facilitate joint initiatives where collective action adds value or creates efficiencies to the benefit of members  Strengthen member visibility and internal communication  • Propose targeted coordination sessions between IF technical, legal or operational representatives where shared risks or developments arise and consensus exists amongst IF leadership • Act as a conduit for formal and informal cross-member signposting on regulatory developments, whether related to shared obligations across all IFs or specific to certain types of sport  • Explore creation of a digital platform to host and communicate tools and resources • Highlight member contributions and best practice case studies • Introduce an annual feedback mechanism enabling ASOIF to gauge the perspective of members to ensure strategic coordination efforts remain relevant and member-driven  • Convene joint initiatives or joint positions on matters where collective IF influence strengthens outcomes, including unplanned issues affecting multiple IFs  ASOIF coordinates strategic collaboration and communication across the Summer Olympic IFs  ASO IF ST R AT EGY 2 02 6 – 2 032  14"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 15-title-1" style="top:324px;left:62px;" src="/strategy/static/_content/15-title-1.png"/>
        <img class="abs halfScale 15-sub-1" style="top:405px;left:65px;" src="/strategy/static/_content/15-sub-1.png"/>
        <img class="abs halfScale 15-sub-2" style="top:405px;left:642px;" src="/strategy/static/_content/15-sub-2.png"/>
        <img class="abs halfScale 15-sub-3" style="top:405px;left:836px;" src="/strategy/static/_content/15-sub-3.png"/>
        <img class="abs halfScale 15-sub-4" style="top:405px;left:1029px;" src="/strategy/static/_content/15-sub-4.png"/>
        <img class="abs halfScale 15-line-1" style="top:439px;left:64px;" src="/strategy/static/_content/15-line-1.png"/>
        <img class="abs halfScale 15-line-2" style="top:439px;left:642px;" src="/strategy/static/_content/15-line-2.png"/>
        <img class="abs halfScale 15-line-3" style="top:439px;left:834px;" src="/strategy/static/_content/15-line-2.png"/>
        <img class="abs halfScale 15-line-4" style="top:439px;left:1028px;" src="/strategy/static/_content/15-line-2.png"/>
        <img class="abs halfScale 15-line-5" style="top:441px;left:64px;" src="/strategy/static/_content/15-line-3.png"/>
        <img class="abs halfScale 15-line-6" style="top:441px;left:332px;" src="/strategy/static/_content/15-line-3.png"/>
        <img class="abs halfScale 15-line-7" style="top:441px;left:642px;" src="/strategy/static/_content/15-line-3.png"/>
        <img class="abs halfScale 15-line-8" style="top:441px;left:835px;" src="/strategy/static/_content/15-line-3.png"/>
        <img class="abs halfScale 15-line-9" style="top:441px;left:1028px;" src="/strategy/static/_content/15-line-3.png"/>
        <img class="abs halfScale 15-text-1" style="top:463px;left:81px;" src="/strategy/static/_content/15-text-1.png"/>
        <img class="abs halfScale 15-text-1" style="top:540px;left:81px;" src="/strategy/static/_content/15-text-2.png"/>
        <img class="abs halfScale 15-text-1" style="top:599px;left:81px;" src="/strategy/static/_content/15-text-3.png"/>
        <img class="abs halfScale 15-text-1" style="top:675px;left:81px;" src="/strategy/static/_content/15-text-4.png"/>
        <img class="abs halfScale 15-text-1" style="top:752px;left:81px;" src="/strategy/static/_content/15-text-5.png"/>
        <img class="abs halfScale 15-text-1" style="top:463px;left:350px;" src="/strategy/static/_content/15-text-6.png"/>
        <img class="abs halfScale 15-text-1" style="top:540px;left:350px;" src="/strategy/static/_content/15-text-7.png"/>
        <img class="abs halfScale 15-text-1" style="top:615px;left:350px;" src="/strategy/static/_content/15-text-8.png"/>
        <img class="abs halfScale 15-text-1" style="top:675px;left:350px;" src="/strategy/static/_content/15-text-9.png"/>
        <img class="abs halfScale 15-text-1" style="top:752px;left:350px;" src="/strategy/static/_content/15-text-10.png"/>

        <img class="abs halfScale 15-text-2" style="top:461px;left:661px;" src="/strategy/static/_content/15-text-11.png"/>
        <img class="abs halfScale 15-text-2" style="top:570px;left:661px;" src="/strategy/static/_content/15-text-12.png"/>
        <img class="abs halfScale 15-text-3" style="top:461px;left:851px;" src="/strategy/static/_content/15-text-13.png"/>
        <img class="abs halfScale 15-text-4" style="top:461px;left:1044px;" src="/strategy/static/_content/15-text-14.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.fromTo(cOf("15-title-1"), 0.6, {opacity: 0, x: 60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("15-line-1"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("15-sub-1"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.3")
          .fromTo(cOf("15-line-5"), 0.4, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.3")
          .staggerFromTo(cOf("15-text-1"), 0.4, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, "-=0.4")
          .fromTo(cOf("15-line-6"), 0.4, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.7")
          .fromTo(cOf("15-line-2"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.6")
          .fromTo(cOf("15-sub-2"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.3")
          .fromTo(cOf("15-line-7"), 0.4, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.3")
          .staggerFromTo(cOf("15-text-2"), 0.4, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, "-=0.4")
          .fromTo(cOf("15-line-8"), 0.4, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.2")
          .fromTo(cOf("15-line-3"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.6")
          .fromTo(cOf("15-sub-3"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.3")
          .fromTo(cOf("15-text-3"), 0.4, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.2")
          .fromTo(cOf("15-line-4"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.2")
          .fromTo(cOf("15-sub-4"), 0.6, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.6")
          .fromTo(cOf("15-line-9"), 0.4, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.2")
          .fromTo(cOf("15-text-4"), 0.4, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut},"-=0.2")
        }

        function onPageLeave() {
          pg15Anim.stop();
        }
      `,
      "searchText": "TIMELINE 2025  2026  2027  2028  MARCH  AUGUST  Q1 ONWARDS  Q2  Q4  Member Consultation Established  Member and External Consultation Interviews  APRIL  SEPTEMBER  ASOIF Strategy Implementation, Monitoring & Refinement  ASOIF General Assembly – Strategy Update to Membership  ASOIF Strategy Review & Evaluation Post-LA28 Olympic & Paralympic Games  Member Survey  ASOIF Strategy Paper Development  MAY Member Consultation Interviews  OCTOBER ASOIF Council Consultation  JUNE  NOVEMBER  ASOIF General Assembly & Working Meeting (Strategy)  ASOIF Strategy Paper Completion  JULY  OCTOBER – DECEMBER  Member and External Consultation Interviews  ASOIF Strategy Implementation Planning  Q2 ASOIF General Assembly – Strategy Update to Membership  ASO IF ST R AT EGY 2 02 6 – 2 032  15"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:info@asoif.com" target="_blank">
          <div class="addContentLink" style="top: 267px;left: 110px;width: 119px;height: 24px;"></div>
        </a>  
        <a href="https://www.asoif.com" target="_blank">
          <div class="addContentLink" style="top: 299px;left: 61px;width: 122px;height: 24px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "ASOIF Association of Summer Olympic International Federations Maison du Sport International Av. de Rhodanie 54 1007 Lausanne Switzerland Tel.: +41 21 601 48 88 Email: info@asoif.com www.asoif.com"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js